export const capitalizeSentence = (str: string): string => {
    const words = str.split(' ');
    let capitalized = '';
    words.forEach((word) => {
        capitalized += ` ${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
    });
    return capitalized.trim();
};
